
import type { SVGProps } from 'react';
const SvgVisibilityOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#visibility-off_svg__a)">
      <path
        fill="#263E6A"
        d="m15.446 12.646-.796-.796q.225-1.31-.742-2.267-.968-.958-2.258-.733l-.796-.796q.252-.104.526-.156a3.4 3.4 0 0 1 .62-.052q1.53 0 2.591 1.063 1.063 1.062 1.063 2.591 0 .345-.052.64a2 2 0 0 1-.156.506m3.162 3.073-.758-.669a11 11 0 0 0 1.688-1.588A9 9 0 0 0 20.8 11.5q-1.25-2.524-3.588-4.013Q14.875 6 12 6q-.724 0-1.425.1a10 10 0 0 0-1.375.3l-.78-.78a9 9 0 0 1 1.772-.475A11.4 11.4 0 0 1 12 5q3.255 0 5.956 1.79 2.7 1.789 3.967 4.71-.536 1.207-1.359 2.266a11.3 11.3 0 0 1-1.956 1.953m1.115 5.42-3.892-3.881q-.664.294-1.647.518A10 10 0 0 1 12 18q-3.275 0-5.956-1.79-2.681-1.789-3.967-4.71.582-1.324 1.536-2.482A11 11 0 0 1 5.65 7.077l-2.788-2.8.707-.708 16.862 16.862zM6.358 7.785q-.86.61-1.758 1.607A8.2 8.2 0 0 0 3.2 11.5q1.25 2.524 3.587 4.012T12 17q.865 0 1.744-.168.88-.17 1.321-.34l-1.63-1.642a2.3 2.3 0 0 1-.66.218q-.423.086-.775.086-1.53 0-2.591-1.063Q8.346 13.03 8.346 11.5q0-.332.086-.746t.218-.689z"
      />
    </g>
    <defs>
      <clipPath id="visibility-off_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVisibilityOff;
